const ConfigureEnvironment = () => import("Core/configuration/environment/views/ConfigureEnvironment");

// ROUTE OPTION - `pathToRegexpOptions: { strict: true }` makes trailing slashes fail to match path
export default {
    children: [
        {
            path: "configuration/configure_environment",
            name: "settings_configure_environment",
            component: ConfigureEnvironment,
            meta: {
                requiresAuth: true,
                title: "lang.configure_environment",
                restrict_by_login_type: ["employee"],
                restrict_by_permission: ["configuration.read"],
            },
        },
    ],
};
